import { c as _c } from "react/compiler-runtime";
import { ChevronRight } from 'lucide-react';
import { PrV2FilePathLabel } from '../../shared/pr-v2-file-path-label';
import { PrV2FileTypeIcon } from '../../shared/pr-v2-file-type-icon';
import { cn } from '@/lib/utils';
type PrV2FileHeaderToggleButtonProps = {
  filename: string;
  isCollapsed: boolean;
  onToggleCollapsed: () => void;
};
export function PrV2FileHeaderToggleButton(t0) {
  const $ = _c(18);
  const {
    filename,
    isCollapsed,
    onToggleCollapsed
  } = t0;
  const t1 = isCollapsed ? `Expand ${filename}` : `Collapse ${filename}`;
  const t2 = `pr-v2-file-header-toggle-${filename}`;
  let t3;
  if ($[0] !== filename) {
    t3 = <PrV2FileTypeIcon filename={filename} className="absolute inset-0 m-auto size-3 transition-opacity duration-150 ease-out group-hover/file-header:opacity-0 group-focus-visible/toggle:opacity-0 [@media(hover:none)]:opacity-0" />;
    $[0] = filename;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = !isCollapsed && "rotate-90";
  let t5;
  if ($[2] !== t4) {
    t5 = cn("absolute inset-0 size-3.5 text-zinc-500 opacity-0 transition-[opacity,transform] duration-150 ease-out group-hover/file-header:opacity-100 group-focus-visible/toggle:opacity-100 [@media(hover:none)]:opacity-100", t4);
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t5) {
    t6 = <ChevronRight className={t5} />;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t3 || $[7] !== t6) {
    t7 = <span className="relative size-3.5 shrink-0">{t3}{t6}</span>;
    $[6] = t3;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== filename) {
    t8 = <PrV2FilePathLabel filename={filename} basenameClassName="text-[13px] font-medium" directoryClassName="text-[13px]" />;
    $[9] = filename;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== filename || $[12] !== onToggleCollapsed || $[13] !== t1 || $[14] !== t2 || $[15] !== t7 || $[16] !== t8) {
    t9 = <button type="button" onClick={onToggleCollapsed} aria-label={t1} data-testid={t2} data-filename={filename} data-pr-v2-file-nav-hotkey-target="true" data-pr-v2-file-header-control="true" className="group/toggle flex min-w-0 max-w-full items-center gap-2 rounded-sm px-1 py-0.5 text-left transition-colors focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-zinc-600">{t7}{t8}</button>;
    $[11] = filename;
    $[12] = onToggleCollapsed;
    $[13] = t1;
    $[14] = t2;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}